<app-modals id="trials" [title]="title" [description]="description" [openModal]="openModal" [onDismiss]="onDismiss" [showFooter]="false" [isCloseEnabled]="false">
  <div class="row text-center">
    <div class="col-12" [innerHTML]="'MODALS.TRIALS.CONTENT'| translate"></div>
  </div>
  <div class="row mt-4">
    <div class="col-12 text-center">
      <div class="btn-toolbar d-block mx-auto"><button class="btn v-btn-primary" type="button" (click)="goToConfiguration()">{{ 'BUTTONS.UPGRADE' | translate }}</button><a class="btn v-btn-secondary" href="https://calendly.com/vitay/vitay_demo" target="_blank" rel="noopener noreferrer">{{ 'BUTTONS.DEMO' | translate }}</a></div>
    </div>
  </div>
</app-modals>
